import React, {useState} from 'react';
import BaseTableView from "../cmsbase/BaseTableView";
import NetworkWrapper from "../NetworkWrapper";
import {useGet} from "../../network/useGet";
import {cabinMessagesTableFields} from "../../network/mockData";
import {Calendar} from "primereact/calendar";
import {dateToDMY} from "../../utils/dateUtils";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import SendMessageForm from "./SendMessageForm";
import ClearMessagesModal from "./ClearMessagesModal";

function Messages(props) {
    const [ reloadTriggerCount, setReloadTriggerCount ] = useState(1);
    const [ showAddForm, setAddShowForm ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ showDetailsModal, setShowDetailsModal ] = useState(false);
    const [ selectedId, setSelectedId ] = useState(null);
    const [ date, setDate ] = useState(new Date());
    const dateString = dateToDMY(date);
    const { isLoading, data, error } = useGet(`cabinmessage/log?date=${dateString}`, reloadTriggerCount);


    return (
        <NetworkWrapper isLoading={isLoading} error={error}>
            {data &&
            <div>
                <div className="flex items-center justify-between">
                    <div>
                        <label htmlFor="date-from-input"> Messages sent on </label>
                        <div>
                            <Calendar inputId="date-input"
                                      dateFormat="dd/mm/yy"
                                      value={date}
                                      onChange={(e) => setDate(e.value)}/>
                        </div>
                    </div>
                    <div>
                        <Button
                            label="Clear messages"
                            onClick={() => setShowDeleteModal(true)}
                        />
                    </div>
                    <div>
                        <Button label="New message" onClick={() => setAddShowForm(true)}/>
                    </div>
                </div>

                {showDeleteModal &&
                <ClearMessagesModal setShowDeleteModal={setShowDeleteModal} />
                }

                <div style={{display: "grid", gridTemplateColumns: "3fr minmax(250px, 1fr)"}}>
                    <BaseTableView
                        idField="sourceMessageId"
                        data={data?.messages}
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        setShowForm={setShowDetailsModal}
                        tableFields={cabinMessagesTableFields}
                    />

                    { showAddForm &&
                        <div className="ml-4">
                            <SendMessageForm
                            onClose={() => setAddShowForm(false)}
                            setReloadTriggerCount={setReloadTriggerCount}
                            />
                        </div>
                    }
                </div>


                <Dialog
                    visible={showDetailsModal}
                    header="Message details"
                    style={{ width: '60vw' }}
                    footer={(<Button label="Close" icon="pi pi-times" onClick={() => {setShowDetailsModal(false); setSelectedId(null)}} className="p-button-text" />)}
                    onHide={() => {setShowDetailsModal(false); setSelectedId(null)}}
                    baseZIndex={1000}
                >
                    {selectedId &&
                    <MessageDetails id={selectedId} message={data.messages.find(el => el.sourceMessageId === selectedId)}/>
                    }
                </Dialog>
            </div>
            }
        </NetworkWrapper>
    );
}

export default Messages;



function MessageDetails(props) {
    const { isLoading, data, error } = useGet(`cabinmessage/log/details/${props.id}`);

    return (
        <NetworkWrapper isLoading={isLoading} error={error}>
            {data &&
            <div>
                <div className="text-lg mt-4">
                    {props.message.sourceMessageTitle.defaultPlainValue}
                </div>
                <div className="mt-2">
                    {props.message.sourceMessageContent.defaultPlainValue}
                </div>
                <div className="mt-4">
                    Cabins that have read the message: {data.read.length ? data.read.join(", ") : "None"}
                </div>
                <div className="mt-2">
                    Cabins that have not read the message: { data.unRead.length ? data.unRead.join(", ") : "None"}
                </div>
            </div>
            }
        </NetworkWrapper>
        )
}

